<div #clipPath
     [class]="currentGuide && positioned && 'user-guide-overlay' || 'user-guide-pre'"
     (click)="hideGuide(false, $event)"
>
  <div class="popover user-guide-info" #infoBox [ngStyle]="{maxWidth: steps[currentStep]?.maxWidth}">
    <div class="popover-header user-guide-title">
      {{steps[currentStep] && steps[currentStep].title || ('Step #'|translate) + (currentStep + 1)}}
    </div>
    <div class="popover-body user-guide-text d-flex flex-column gap-2">
      <div [innerHTML]="steps[currentStep] && steps[currentStep].text"></div>
      <div *ngIf="!(steps[currentStep] && steps[currentStep].hideButtons)" class="d-flex justify-content-end gap-2">
        <app-button *ngIf="currentStep === 0" variant="light" size="sm" (click)="hideGuide(true)">{{'Skip'|translate}}</app-button>
        <app-button *ngIf="currentStep !== 0 && !steps[currentStep]?.hideBackButton" variant="light" size="sm" (click)="backButtonClick($event)">{{'Back'|translate}}</app-button>
        <app-button *ngIf="steps[currentStep] && steps[currentStep].nextButtonHandler"
                    size="sm" (click)="steps[currentStep].nextButtonHandler($event)">
          {{steps[currentStep].nextButtonCaption || ('Next'|translate)}}</app-button>
      </div>
    </div>
  </div>
</div>
